module.exports = __webpack_public_path__ + "img/sudan.ece9da9b.svg";